'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.categories.show', [])
  .controller('CategoriesShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/categories/show/index.js